// import React, { useEffect, useState } from "react";
// import Paper from "@mui/material/Paper";
// import Box from "@mui/material/Box";
// import { alpha, styled } from "@mui/material/styles";
// import { Button, CircularProgress, TablePagination } from "@mui/material";
// import Grid from "@mui/material/Grid";
// import Typography from "@mui/material/Typography";
// import TextField from "@mui/material/TextField";
// import FormGroup from "@mui/material/FormGroup";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import FormControl from "@mui/material/FormControl";
// import Checkbox from "@mui/material/Checkbox";
// import moment from "moment";
// import Select, { SelectChangeEvent } from "@mui/material/Select";
// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import createInstance from "../../../api/axiosinstance";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import Toast from "../../../utils/toast";
// import { toast } from "react-toastify";
// // import COLORS from "../../Themes/Colours";
// import { useThemeMode } from "../../Themes/ThemeContextTemp.js";

// const CssTextField = styled(TextField)({
//   "& label.Mui-focused": {
//     color: COLORS.text,
//   },
//   "& label": {
//     color: COLORS.text,
//   },
//   "& .MuiInput-underline:after": {
//     borderBottomColor: COLORS.border,
//   },
//   "& .MuiOutlinedInput-root": {
//     "& fieldset": {
//       borderColor: COLORS.border,
//       borderRadius: 10,
//     },
//     "&:hover fieldset": {
//       borderColor:COLORS.border,
//     },
//     "&.Mui-focused fieldset": {
//       borderColor: COLORS.border,
//     },
//     "& .MuiInputBase-input": {
//       color: COLORS.text,
//     },
//   },
// });

// const CssFormControl = styled(FormControl)({
//   "& label": {
//     color: COLORS.text,
//     "&.Mui-focused": {
//       color: COLORS.text,
//     },
//   },
//   "& .MuiInputBase-root": {
//     color: COLORS.text,
//     "& .MuiOutlinedInput-notchedOutline": {
//       borderColor: COLORS.border,
//       borderRadius: 10,
//     },
//     "&:hover .MuiOutlinedInput-notchedOutline": {
//       borderColor: COLORS.border,
//     },
//     "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//       borderColor: COLORS.border,
//     },
//   },
// });

// const CssSelect = styled(Select)({
//   "& .MuiSvgIcon-root": {
//     color: COLORS.text,
//     textAlign: "center",
//   },
// });

// const AddOrganization = ({ orgData }) => {
//   const aiDishaApi = createInstance("DISHA");
//   const [creationDate] = useState(new Date().toISOString());
//   const isEditMode = orgData ? true : false;
//   const [name, setName] = useState("");
//   const [domain, setDomain] = useState("");
//   const [emailId, setEmailId] = useState("");
//   const [contact, setContact] = useState("");
//   const [address, setAddress] = useState("");
//   const [sector, setSector] = useState("");
//   const [orgId, setOrgId] = useState(
//     isEditMode ? orgData.organization_id : null
//   );
//   const [activeSectors, setActiveSectors] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [orgLogo, setOrgLogo] = useState(null); // State for logo file
//   const { COLORS } = useThemeMode();

//   const clearForm = () => {
//     if (isEditMode) {
//       setName(orgData.organization_name);
//       setDomain(orgData.organization_domain);
//       setEmailId(orgData.email);
//       setContact(orgData.contact_number);
//       setAddress(orgData.organization_address);
//       setSector(orgData.sector);
//       setOrgLogo(null); // Reset logo in edit mode
//     } else {
//       setName("");
//       setDomain("");
//       setEmailId("");
//       setContact("");
//       setAddress("");
//       setSector("");
//       setOrgLogo(null); // Clear logo in add mode
//     }
//   };

//   useEffect(() => {
//     getActiveSectors();

//     if (orgData) {
//       setName(orgData.organization_name);
//       setDomain(orgData.organization_domain);
//       setEmailId(orgData.email);
//       setContact(orgData.contact_number);
//       setAddress(orgData.organization_address);
//       setSector(orgData.sector);
//       setOrgId(orgData.organization_id);
//     }
//   }, [orgData]);

//   const getActiveSectors = async () => {
//     try {
//       const response = await aiDishaApi.get("/sectors-show-active");
//       setActiveSectors(response.data["sectors"]);
//       console.log(response.data);
//     } catch (error) {
//       console.error("Error fetching sectors:", error);
//     }
//   };

//   const handleLogoChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setOrgLogo(file); // Set the selected file to state
//     }
//   };

//   const handleSubmit = async () => {
//     setLoading(true);

//     try {
//       const formData = new FormData();
//       formData.append("organization_name", name);
//       formData.append("organization_domain", domain);
//       formData.append("email", emailId);
//       formData.append("contact_number", contact);
//       formData.append("organization_address", address);
//       formData.append("status", "Active");
//       if (!isEditMode) {
//         formData.append("creation_date", creationDate);
//       }
//       if (orgLogo) {
//         formData.append("org_logo", orgLogo); // Append logo file if selected
//       }

//       if (isEditMode) {
//         // Update existing organization
//         const response = await aiDishaApi.put(
//           `/edit-organization/${orgId}`,
//           formData,
//           {
//             headers: { "Content-Type": "multipart/form-data" },
//           }
//         );
//         console.log("Org updated successfully ", response.data);
//         toast.success("Organization updated successfully");
//       } else {
//         // Create new organization
//         const response = await aiDishaApi.post("/add-organization", formData, {
//           params: { sector: sector },
//           headers: { "Content-Type": "multipart/form-data" },
//         });
//         clearForm();
//         console.log("Org added successfully ", response.data);
//         toast.success("Organization added successfully");
//       }
//     } catch (error) {
//       console.log(error)
//       console.log(
//         "Error with organization operation",
//         error.response?.data?.detail || error.message
//       );
//       toast.error(
//         isEditMode ? "Error updating organization" : "Error adding organization"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div>
//       <Box
//         display="grid"
//         gridTemplateColumns="repeat(12, 1fr)"
//         sx={{
//           marginTop: "auto",
//           alignItems: "center",
//           borderRadius: "10px",
//           padding: "1% 10%",
//         }}
//       >
//         <Box
//           gridColumn="span 12"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "0%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", fontSize: "28px", color: COLORS.text }}
//           >
//             {isEditMode ? "Edit Organization" : "Add Organization"}
//           </Typography>
//         </Box>
//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Organization Name<span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssTextField
//             label="Enter Organization Name"
//             id="custom-css-outlined-input"
//             size="small"
//             sx={{ width: "95%" }}
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//           />
//         </Box>
//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Organization Domain<span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssTextField
//             label="Enter Organization Domain"
//             id="custom-css-outlined-input"
//             size="small"
//             sx={{ width: "95%" }}
//             value={domain}
//             onChange={(e) => setDomain(e.target.value)}
//           />
//         </Box>
//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Email ID<span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssTextField
//             label="Enter contact mail id"
//             id="custom-css-outlined-input"
//             size="small"
//             sx={{ width: "95%" }}
//             value={emailId}
//             onChange={(e) => setEmailId(e.target.value)}
//           />
//         </Box>
//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Contact Number<span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssTextField
//             label="Enter contact number"
//             id="custom-css-outlined-input"
//             size="small"
//             sx={{ width: "95%" }}
//             value={contact}
//             onChange={(e) => setContact(e.target.value)}
//           />
//         </Box>
//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color:COLORS.text, textAlign: "left" }}
//           >
//             Organization Address<span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssTextField
//             label="Enter Organization Address"
//             id="custom-css-outlined-input"
//             size="small"
//             sx={{ width: "98%" }}
//             value={address}
//             onChange={(e) => setAddress(e.target.value)}
//           />
//         </Box>
//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Sector<span style={{ color: "red" }}>*</span>
//           </Typography>
//           <CssFormControl sx={{ width: "95%" }}>
//             <InputLabel sx={{ color: COLORS.text }}>Select Sector</InputLabel>
//             <CssSelect
//               label="Select Type of Sector"
//               id="demo-simple-select-outlined"
//               size="small"
//               value={sector}
//               onChange={(e) => setSector(e.target.value)}
//               sx={{ width: "100%", textAlign: "center" }}
//             >
//               <MenuItem value="" sx={{ color: COLORS.text }}>
//                 <em>Select Sector</em>
//               </MenuItem>
//               {activeSectors.map((sector, index) => (
//                 <MenuItem
//                   key={sector.sector_id || `${sector.sector_name}-${index}`} // Use sector_id if available, else fallback to name with index
//                   value={sector.sector_name}
//                   sx={{ color: COLORS.text }}
//                 >
//                   {sector.sector_name}
//                 </MenuItem>
//               ))}
//             </CssSelect>
//           </CssFormControl>
//         </Box>
//         <Box
//           gridColumn="span 6"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Typography
//             sx={{ fontFamily: "poppins", color: COLORS.text, textAlign: "left" }}
//           >
//             Organization Logo
//           </Typography>
//           <input
//             type="file"
//             accept="image/*"
//             onChange={handleLogoChange}
//             style={{ marginTop: "8px", color: COLORS.text }}
//           />
//           {orgLogo && (
//             <Typography
//               sx={{ fontFamily: "poppins", color: COLORS.text, marginTop: "8px" }}
//             >
//               Selected: {orgLogo.name}
//             </Typography>
//           )}
//         </Box>
//         <Box
//           gridColumn="span 12"
//           sx={{ marginTop: "auto", textAlign: "right", width: "90%" }}
//         >
//           <Button
//             sx={{
//               border: "1px solid",
//               color: COLORS.button,
//               "&:hover":{
//                 color: COLORS.hover_btn,
//               },
//               width: "120px",
//               height: "35px",
//               borderRadius: "10px",
//               marginRight: "2%",
//             }}
//             onClick={clearForm}
//             disabled={loading}
//           >
//             {isEditMode ? "Reset" : "Clear"}
//           </Button>
//           <Button
//             sx={{
//               border: "1px solid",
//               background: COLORS.button,
//               color:COLORS.background,
//               "&:hover":{
//                 background: COLORS.hover_btn,
//               },
//               width: "120px",
//               height: "35px",
//               borderRadius: "10px",
//               // backgroundColor: "#033538",
//               position: "relative",
//               // "&:hover": {
//               //   backgroundColor: "white",
//               //   color: "#033538",
//               //   border: "1px solid #033538",
//               // },
//             }}
//             onClick={handleSubmit}
//             disabled={loading}
//           >
//             {loading ? (
//               <CircularProgress
//                 size={24}
//                 sx={{
//                   background: COLORS.button,
//                   color:COLORS.background,
//                   "&:hover":{
//                     background: COLORS.hover_btn,
//                   },
//                   position: "absolute",
//                   top: "50%",
//                   left: "50%",
//                   marginTop: "-12px",
//                   marginLeft: "-12px",
//                 }}
//               />
//             ) : isEditMode ? (
//               "Update"
//             ) : (
//               "Submit"
//             )}
//           </Button>
//         </Box>
//       </Box>
//     </div>
//   );
// };

// export default AddOrganization;

































import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { alpha, styled } from "@mui/material/styles";
import { Button, CircularProgress, TablePagination } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import moment from "moment";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import createInstance from "../../../api/axiosinstance";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Toast from "../../../utils/toast";
import { toast } from "react-toastify";
// import COLORS from "../../Themes/Colours";
import { useThemeMode } from "../../Themes/ThemeContextTemp.js";

// ✅ FIXED: Styled components without COLORS (they'll be added via sx prop)
const CssTextField = styled(TextField)({
  "& label": {
    "&.Mui-focused": {
      // Color will be set via sx prop
    },
  },
  "& .MuiInput-underline:after": {
    // Border color will be set via sx prop
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderRadius: 10,
    },
    "& .MuiInputBase-input": {
      // Color will be set via sx prop
    },
  },
});

const CssFormControl = styled(FormControl)({
  "& label": {
    "&.Mui-focused": {
      // Color will be set via sx prop
    },
  },
  "& .MuiInputBase-root": {
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: 10,
    },
  },
});

const CssSelect = styled(Select)({
  "& .MuiSvgIcon-root": {
    textAlign: "center",
    // Color will be set via sx prop
  },
});

const AddOrganization = ({ orgData }) => {
  const aiDishaApi = createInstance("DISHA");
  const [creationDate] = useState(new Date().toISOString());
  const isEditMode = orgData ? true : false;
  const [name, setName] = useState("");
  const [domain, setDomain] = useState("");
  const [emailId, setEmailId] = useState("");
  const [contact, setContact] = useState("");
  const [address, setAddress] = useState("");
  const [sector, setSector] = useState("");
  const [orgId, setOrgId] = useState(
    isEditMode ? orgData.organization_id : null
  );
  const [activeSectors, setActiveSectors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [orgLogo, setOrgLogo] = useState(null); // State for logo file
  const { COLORS } = useThemeMode();

  const clearForm = () => {
    if (isEditMode) {
      setName(orgData.organization_name);
      setDomain(orgData.organization_domain);
      setEmailId(orgData.email);
      setContact(orgData.contact_number);
      setAddress(orgData.organization_address);
      setSector(orgData.sector);
      setOrgLogo(null); // Reset logo in edit mode
    } else {
      setName("");
      setDomain("");
      setEmailId("");
      setContact("");
      setAddress("");
      setSector("");
      setOrgLogo(null); // Clear logo in add mode
    }
  };

  useEffect(() => {
    getActiveSectors();

    if (orgData) {
      setName(orgData.organization_name);
      setDomain(orgData.organization_domain);
      setEmailId(orgData.email);
      setContact(orgData.contact_number);
      setAddress(orgData.organization_address);
      setSector(orgData.sector);
      setOrgId(orgData.organization_id);
    }
  }, [orgData]);

  const getActiveSectors = async () => {
    try {
      const response = await aiDishaApi.get("/sectors-show-active");
      setActiveSectors(response.data["sectors"]);
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching sectors:", error);
    }
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setOrgLogo(file); // Set the selected file to state
    }
  };

  const handleSubmit = async () => {
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("organization_name", name);
      formData.append("organization_domain", domain);
      formData.append("email", emailId);
      formData.append("contact_number", contact);
      formData.append("organization_address", address);
      formData.append("status", "Active");
      if (!isEditMode) {
        formData.append("creation_date", creationDate);
      }
      if (orgLogo) {
        formData.append("org_logo", orgLogo); // Append logo file if selected
      }

      if (isEditMode) {
        // Update existing organization
        const response = await aiDishaApi.put(
          `/edit-organization/${orgId}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        console.log("Org updated successfully ", response.data);
        toast.success("Organization updated successfully");
      } else {
        // Create new organization
        const response = await aiDishaApi.post("/add-organization", formData, {
          params: { sector: sector },
          headers: { "Content-Type": "multipart/form-data" },
        });
        clearForm();
        console.log("Org added successfully ", response.data);
        toast.success("Organization added successfully");
      }
    } catch (error) {
      console.log(error)
      console.log(
        "Error with organization operation",
        error.response?.data?.detail || error.message
      );
      toast.error(
        isEditMode ? "Error updating organization" : "Error adding organization"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        sx={{
          marginTop: "auto",
          alignItems: "center",
          borderRadius: "10px",
          padding: "1% 10%",
        }}
      >
        <Box
          gridColumn="span 12"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "0%" }}
        >
          <Typography
            sx={{ 
              fontFamily: "poppins", 
              fontSize: "28px", 
              color: COLORS.text // ✅ Using COLORS from hook
            }}
          >
            {isEditMode ? "Edit Organization" : "Add Organization"}
          </Typography>
        </Box>

        {/* Organization Name Field */}
        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ 
              fontFamily: "poppins", 
              color: COLORS.text, // ✅ Using COLORS from hook
              textAlign: "left" 
            }}
          >
            Organization Name<span style={{ color: "red" }}>*</span>
          </Typography>
          <CssTextField
            label="Enter Organization Name"
            id="custom-css-outlined-input"
            size="small"
            sx={{ 
              width: "95%",
              // ✅ COLORS styling via sx prop
              "& label": { color: COLORS.text },
              "& label.Mui-focused": { color: COLORS.text },
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: COLORS.border },
                "&:hover fieldset": { borderColor: COLORS.border },
                "&.Mui-focused fieldset": { borderColor: COLORS.border },
                "& .MuiInputBase-input": { color: COLORS.text },
              },
            }}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Box>

        {/* Organization Domain Field */}
        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ 
              fontFamily: "poppins", 
              color: COLORS.text, // ✅ Using COLORS from hook
              textAlign: "left" 
            }}
          >
            Organization Domain<span style={{ color: "red" }}>*</span>
          </Typography>
          <CssTextField
            label="Enter Organization Domain"
            id="custom-css-outlined-input"
            size="small"
            sx={{ 
              width: "95%",
              // ✅ COLORS styling via sx prop
              "& label": { color: COLORS.text },
              "& label.Mui-focused": { color: COLORS.text },
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: COLORS.border },
                "&:hover fieldset": { borderColor: COLORS.border },
                "&.Mui-focused fieldset": { borderColor: COLORS.border },
                "& .MuiInputBase-input": { color: COLORS.text },
              },
            }}
            value={domain}
            onChange={(e) => setDomain(e.target.value)}
          />
        </Box>

        {/* Email ID Field */}
        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ 
              fontFamily: "poppins", 
              color: COLORS.text, // ✅ Using COLORS from hook
              textAlign: "left" 
            }}
          >
            Email ID<span style={{ color: "red" }}>*</span>
          </Typography>
          <CssTextField
            label="Enter contact mail id"
            id="custom-css-outlined-input"
            size="small"
            sx={{ 
              width: "95%",
              // ✅ COLORS styling via sx prop
              "& label": { color: COLORS.text },
              "& label.Mui-focused": { color: COLORS.text },
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: COLORS.border },
                "&:hover fieldset": { borderColor: COLORS.border },
                "&.Mui-focused fieldset": { borderColor: COLORS.border },
                "& .MuiInputBase-input": { color: COLORS.text },
              },
            }}
            value={emailId}
            onChange={(e) => setEmailId(e.target.value)}
          />
        </Box>

        {/* Contact Number Field */}
        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ 
              fontFamily: "poppins", 
              color: COLORS.text, // ✅ Using COLORS from hook
              textAlign: "left" 
            }}
          >
            Contact Number<span style={{ color: "red" }}>*</span>
          </Typography>
          <CssTextField
            label="Enter contact number"
            id="custom-css-outlined-input"
            size="small"
            sx={{ 
              width: "95%",
              // ✅ COLORS styling via sx prop
              "& label": { color: COLORS.text },
              "& label.Mui-focused": { color: COLORS.text },
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: COLORS.border },
                "&:hover fieldset": { borderColor: COLORS.border },
                "&.Mui-focused fieldset": { borderColor: COLORS.border },
                "& .MuiInputBase-input": { color: COLORS.text },
              },
            }}
            value={contact}
            onChange={(e) => setContact(e.target.value)}
          />
        </Box>

        {/* Organization Address Field */}
        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ 
              fontFamily: "poppins", 
              color: COLORS.text, // ✅ Using COLORS from hook
              textAlign: "left" 
            }}
          >
            Organization Address<span style={{ color: "red" }}>*</span>
          </Typography>
          <CssTextField
            label="Enter Organization Address"
            id="custom-css-outlined-input"
            size="small"
            sx={{ 
              width: "98%",
              // ✅ COLORS styling via sx prop
              "& label": { color: COLORS.text },
              "& label.Mui-focused": { color: COLORS.text },
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: COLORS.border },
                "&:hover fieldset": { borderColor: COLORS.border },
                "&.Mui-focused fieldset": { borderColor: COLORS.border },
                "& .MuiInputBase-input": { color: COLORS.text },
              },
            }}
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
        </Box>

        {/* Sector Select Field */}
        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ 
              fontFamily: "poppins", 
              color: COLORS.text, // ✅ Using COLORS from hook
              textAlign: "left" 
            }}
          >
            Sector<span style={{ color: "red" }}>*</span>
          </Typography>
          <CssFormControl 
            sx={{ 
              width: "95%",
              // ✅ COLORS styling via sx prop
              "& label": { color: COLORS.text },
              "& label.Mui-focused": { color: COLORS.text },
              "& .MuiInputBase-root": {
                color: COLORS.text,
                "& .MuiOutlinedInput-notchedOutline": { borderColor: COLORS.border },
                "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: COLORS.border },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: COLORS.border },
              },
              "& .MuiSvgIcon-root": { color: COLORS.text },
            }}
          >
            <InputLabel sx={{ color: COLORS.text }}>Select Sector</InputLabel>
            <CssSelect
              label="Select Type of Sector"
              id="demo-simple-select-outlined"
              size="small"
              value={sector}
              onChange={(e) => setSector(e.target.value)}
              sx={{ width: "100%", textAlign: "center" }}
            >
              <MenuItem value="" sx={{ color: COLORS.text }}>
                <em>Select Sector</em>
              </MenuItem>
              {activeSectors.map((sector, index) => (
                <MenuItem
                  key={sector.sector_id || `${sector.sector_name}-${index}`}
                  value={sector.sector_name}
                  sx={{ color: COLORS.text }}
                >
                  {sector.sector_name}
                </MenuItem>
              ))}
            </CssSelect>
          </CssFormControl>
        </Box>

        {/* Organization Logo Field */}
        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ 
              fontFamily: "poppins", 
              color: COLORS.text, // ✅ Using COLORS from hook
              textAlign: "left" 
            }}
          >
            Organization Logo
          </Typography>
          <input
            type="file"
            accept="image/*"
            onChange={handleLogoChange}
            style={{ marginTop: "8px", color: COLORS.text }}
          />
          {orgLogo && (
            <Typography
              sx={{ 
                fontFamily: "poppins", 
                color: COLORS.text, // ✅ Using COLORS from hook
                marginTop: "8px" 
              }}
            >
              Selected: {orgLogo.name}
            </Typography>
          )}
        </Box>

        {/* Action Buttons */}
        <Box
          gridColumn="span 12"
          sx={{ marginTop: "auto", textAlign: "right", width: "90%" }}
        >
          <Button
            sx={{
              border: "1px solid",
              color: COLORS.button, // ✅ Using COLORS from hook
              "&:hover": {
                color: COLORS.hover_btn, // ✅ Using COLORS from hook
              },
              width: "120px",
              height: "35px",
              borderRadius: "10px",
              marginRight: "2%",
            }}
            onClick={clearForm}
            disabled={loading}
          >
            {isEditMode ? "Reset" : "Clear"}
          </Button>
          <Button
            sx={{
              border: "1px solid",
              background: COLORS.button, // ✅ Using COLORS from hook
              color: COLORS.background, // ✅ Using COLORS from hook
              "&:hover": {
                background: COLORS.hover_btn, // ✅ Using COLORS from hook
              },
              width: "120px",
              height: "35px",
              borderRadius: "10px",
            }}
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress
                size={24}
                sx={{
                  color: COLORS.background, // ✅ Using COLORS from hook
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            ) : isEditMode ? (
              "Update"
            ) : (
              "Submit"
            )}
          </Button>
        </Box>
      </Box>
    </div>
  );
};

export default AddOrganization;